import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LaborComponent } from './labor/labor.component';
import { VinComponent } from './vin/vin.component';
import { UnconfirmedLaborComponent } from './unconfirmed-labor/unconfirmed-labor.component';
import { AboutComponent } from './about/about.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'labor', component: LaborComponent },
  { path: 'vin', component: VinComponent },
  { path: 'unconfirmedlabor', component: UnconfirmedLaborComponent },
  { path: 'about', component: AboutComponent },
  { path: 'login', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/